import { map, Observable, of } from 'rxjs';
import { HisWidgetUtils } from '../utils/his-widget-utils';
import { HisOption } from './his-option';
import { HisWidgetBaseSelect } from './his-widget-base-select';

export class HisMultiSelectWidget extends HisWidgetBaseSelect<HisOption[]> {
    kind = 'multi-dropdown';
    optionsKey: string;
    options: Observable<HisOption[]>;
    multiple = false;

    constructor( options: any = {} ) {
        super( options );

        this.kind = options.kind || 'multi-dropdown';
        this.optionsKey = options.optionsKey;
        this.options = options.options || of( [] );
        this.multiple = options.multiple;
    }

    protected doPresetInputFields( presetValue: any, onPresetSuccess: () => void ) {
        console.log( 'presetting multi-select field', this.id, 'to', presetValue );

        this.value = [];
        this.originalValue = [];

        if ( !presetValue ) {
            return;
        }

        if ( String( presetValue ).includes( 'ISNULL' ) && this.showNullItem ) {
            const nullOption = new HisOption(null, 'ISNULL'); // label is set at his-search-multiselect.component.ts
            this.value.push( nullOption );
            this.originalValue = [...this.value];

            onPresetSuccess();
        }

        this.getWidgetValues( presetValue ).subscribe( ( values: HisOption[] ) => {
            if ( Array.isArray( values ) && values.length > 0 ) {
                values.forEach( value => this.value.push( value ) );
                this.originalValue = [...this.value];
                
                onPresetSuccess();
            }
        } );
    }

    public getWidgetValueDetail( idsStr: string ) {
        const ids: string[] = HisWidgetUtils.parseArrayString( idsStr );
        return this.options.pipe(
            map( options => {
                const value = ids.map( id => options.find( opt => opt.id === id ) )
                    .filter( option => !!option );
                console.log( 'Multiselect optionsToSet', value );
                return { value, hasUnresolvedId: ids.length != value.length };
            } )
        );
    }
}
